export function formatJson(value: unknown): string {
  return JSON.stringify(value, null, 2) ?? String(value)
}

export function countLines(text: string): number {
  return text.split('\n').length
}
